import React from "react";
import { Container, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ICoreNavbarTop } from "../../../core";

export interface NavbarTopInterface {
    translate: ICoreNavbarTop;
    themeColor: string;
}

export const NavbarTop: React.FC<NavbarTopInterface> = ({ translate, themeColor }) => {
    const NavLinkCustom = ({ to, children, ...props }) => (
        <>
            <Nav.Item className="d-none d-sm-inline">
                <Nav.Link className="text-menu-top py-1 text-capitalize0">
                    <Link to={to} style={{ textDecoration: "none", color: "black" }}>
                        {children}
                    </Link>
                </Nav.Link>
            </Nav.Item>
            {props.division &&
                <Nav.Item className="d-none d-sm-inline">
                    <Nav.Link href="/home" className="text-menu-top py-1">|</Nav.Link>
                </Nav.Item>}
        </>
    )

    return (
        <Nav className={`${themeColor} justify-content-end p-0`} activeKey="/home">
            <Container className='text-menu-top'>
                <Nav className="justify-content-end">
                    <NavLinkCustom to={"/about"} division>{translate.about}</NavLinkCustom>
                    <NavLinkCustom to={"/contact"} division>{translate.contact}</NavLinkCustom>
                    <NavLinkCustom to={"/faq"}>{translate.faq}</NavLinkCustom>
                </Nav>
            </Container>
        </Nav>
    )
}